import React from 'react'
import { Button, Spinner } from 'reactstrap'
import { UserContext } from '../contexts/UserContext'
import useTranslation from 'hooks/UseTranslation'
import { WaitingListStatus } from 'typescript-axios'
import * as fbq from '../../src/lib/fpixel'

export const BOOK_CALLBACK = 1
export const CONTACT_CALLBACK = 2
export const BOOK_CALLBACK_FREE_CLASS = 3
export const JOIN_LIST_CALLBACK = 4

const BookButton = ({
  isDeleted,
  isOwnBooking,
  isBooked,
  isFull,
  waitingListStatus,
  joinListCallback,
  setShowSigninModal,
  setSigninCallback,
  bookCallback,
  isPast,
  setShowPremium,
  setModalContent,
  isLoading,
  initiateCheckout
}) => {
  const { t } = useTranslation()
  const { loggedUser } = React.useContext(UserContext)

  if (isDeleted) {
    return (
      <Button color='light' block disabled>
        {t('cancelled')}
      </Button>
    )
  }
  let color = 'primary'
  let buttonLabel = t('detail_button_book_now')
  let disabled = true
  if (isBooked === null) {
    buttonLabel = <Spinner style={{ width: '1rem', height: '1rem' }} />
  } else if (isBooked === true) {
    buttonLabel = t('detail_button_booked')
  } else if (isPast) {
    buttonLabel = t('detail_button_closed_for_bookings')
  } else if (isFull) {
    if (waitingListStatus == WaitingListStatus.Disabled) {
      color = 'primary'
      disabled = true
      buttonLabel = t('retreat_detail_button_class_full')
      if (isOwnBooking) {
        return (
          <Button color='premium' block onClick={() => setShowPremium(true)}>
            {t('detail_button_class_full_enable_waiting_list')}
          </Button>
        )
      }
    } else {
      color = 'outline-primary'
      if (isOwnBooking) {
        buttonLabel = t('detail_button_class_full_get_in_list')
        disabled = true
      } else if (waitingListStatus == WaitingListStatus.InList) {
        buttonLabel = (
          <span>
            <i className='fas fa-check fa-fw mr-2' />
            {t('detail_button_class_full_is_in_list')}
          </span>
        )
        disabled = true
      } else if (waitingListStatus == WaitingListStatus.NotInList) {
        buttonLabel = (
          <span>
            <i className='fas fa-bell fa-fw mr-2' />
            {t('detail_button_class_full_get_in_list')}
          </span>
        )
        disabled = false
      }
    }
  } else {
    buttonLabel = t('detail_button_book_now')
    disabled = false
  }

  const book = async () => {
    // fixme hardcoded currency
    if (isFull) {
      if (loggedUser) {
        joinListCallback()
      } else {
        setShowSigninModal(true)
        setSigninCallback(JOIN_LIST_CALLBACK)
      }
    } else {
      initiateCheckout && initiateCheckout()
      if (loggedUser) {
        bookCallback()
      } else {
        setShowSigninModal(true)
        setSigninCallback(BOOK_CALLBACK)
      }
    }
  }

  const onClick = isOwnBooking
    ? () =>
        setModalContent({
          isOpen: true,
          title: t('class_detail_modal_is_own_booking_title'),
          msg: t('class_detail_modal_is_own_booking_content')
        })
    : book

  const button = (
    <Button
      color={color}
      block
      disabled={disabled || isLoading}
      onClick={onClick}
    >
      {buttonLabel}
    </Button>
  )
  return button
}

export default BookButton
